import { Workspace_Configuration } from "graphql/generated/graphql";

// get a single workspace config value by key
export const getWorkspaceConfigValue = (state: any, key: string) =>
    state.workspaceConfig?.configList.find((config: Workspace_Configuration) => config.key === key)
        ?.final_value;

export const getWorkspaceConfig = (state: any) => state.workspaceConfig?.configList;
